import { createFileRoute, redirect } from "@tanstack/react-router"
import { z } from "zod"

import SetupTab, {
  isSetupSubTab,
  type SetupSubTab,
} from "~/components/prototype/allocation-planning/setup/SetupTab"

const searchSchema = z.object({ store: z.string().optional(), rule: z.string().optional() })

export const Route = createFileRoute("/_auth/allocation/_layout/settings/$subTab")({
  validateSearch: searchSchema,
  beforeLoad: ({ params }) => {
    if (!isSetupSubTab(params.subTab)) {
      throw redirect({ to: "/allocation/settings/$subTab", params: { subTab: "coverage" } })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { subTab } = Route.useParams()
  const { store, rule } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <SetupTab
      subTab={subTab as SetupSubTab}
      focusStoreId={store}
      focusRuleId={rule}
      onSubTabChange={(next) => navigate({ params: { subTab: next }, search: {} })}
    />
  )
}
